import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['MORE STRUCTURE.', 'MORE CLARITY.', 'BETTER VISUAL EXPLANATIONS.', 'CLEARER PROGRESSIONS.', 'FASTER CORRECTIONS.', 'LESS PLANNING.'];
const alreadyHave = ['You already have the framework.', 'You already have the progression.', 'You already have the 100% visual explanation.', 'You already have the instructor cues.', 'You already have the correction tools.', 'You already have the assessments.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-slate-200" data-id="element-52" data-mp="1dh313lhlpiv9">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-53" data-mp="18m5sgfo8hbiw">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-blue-950 mb-6 uppercase" data-id="element-54" data-mp="1wdb7ismcnzs5">
          Flight Instructors Don&apos;t Need More Random Aviation Information.
        </h2>
        <p className="text-xl text-slate-700 mb-5" data-id="element-55" data-mp="28wy9mufg4hjj">They need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-56" data-mp="28zapn21n8hty">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-orange-500 tracking-wide" data-id="element-57" data-mp="204we9ak8hrg4">
              {need}
            </li>)}
        </ul>
        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-8 text-lg text-slate-800 space-y-2 text-left sm:text-center" data-id="element-58" data-mp="1l62fhqnipa94">
          <p className="mb-4" data-id="element-59" data-mp="1c6xgykbyhgwy">
            With Flight Instructor Ready, you don&apos;t begin every lesson from an empty page.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-blue-950 font-semibold flex items-center sm:justify-center gap-2" data-id="element-60" data-mp="1h84pillxak4o">
              <Check size={18} className="text-blue-600 shrink-0" aria-hidden="true" data-id="element-61" data-mp="3bj06ocb6b7j2" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-62" data-mp="396po1u88kron">And with 150 ready-to-teach flight lessons:</p>
          <p className="text-2xl md:text-3xl font-serif font-extrabold text-blue-950" data-id="element-63" data-mp="35301tbf1am6s">
            YOU ALREADY HAVE <span className="text-orange-500" data-id="element-64" data-mp="30589igah8y22">THE LESSON.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}